export default __webpack_public_path__ + "static/media/pfp5.ba3d30f6.png";